import { createFileRoute } from '@tanstack/react-router';
import { AdminReceiptDetailPage } from './AdminReceiptDetailPage';

export const Route = createFileRoute('/_protected/admin/internal-tools/receipts/$receiptId/')({
  component: AdminReceiptDetailPage,
});
